import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=caa05144&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"
import style0 from "./Dev.vue?vue&type=style&index=0&id=caa05144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa05144",
  null
  
)

export default component.exports